(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  class ScoreboardAnnouncement extends HTMLElement {
    connectedCallback() {
      window.clearInterval(this.timer);
      window.clearTimeout(this.pendingTextSwap);

      const current = this.querySelector('.scoreboard-announcement__message');
      const messages = ['messageOne', 'messageTwo', 'messageThree']
        .map((key) => (this.dataset[key] || '').trim())
        .filter(Boolean);

      if (!current || messages.length < 2) return;

      this.current = current;
      this.messages = messages;
      this.currentIndex = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const interval = Number(this.dataset.interval) || 4800;
      this.nextButton = this.querySelector('.scoreboard-announcement__next');
      this.handleNext = () => this.next();

      if (this.nextButton) {
        this.nextButton.addEventListener('click', this.handleNext);
      }

      if (!this.reducedMotion) {
        this.timer = window.setInterval(() => this.next(), interval);
      }
    }

    next() {
      if (!this.current || !this.messages || this.messages.length < 2) return;

      const nextIndex = (this.currentIndex + 1) % this.messages.length;
      this.currentIndex = nextIndex;
      window.clearTimeout(this.pendingTextSwap);
      this.current.classList.remove('is-visible');
      this.current.classList.add('is-exiting');
      if (this.reducedMotion) {
        this.current.textContent = this.messages[nextIndex];
        this.current.classList.remove('is-exiting');
        this.current.classList.add('is-visible');
        return;
      }
      this.pendingTextSwap = window.setTimeout(() => {
        this.current.textContent = this.messages[nextIndex];
        this.current.classList.remove('is-exiting');
        this.current.classList.add('is-visible');
      }, 270);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      window.clearTimeout(this.pendingTextSwap);
      if (this.nextButton && this.handleNext) {
        this.nextButton.removeEventListener('click', this.handleNext);
      }
    }
  }

  if (!customElements.get('scoreboard-announcement-plain')) {
    customElements.define('scoreboard-announcement-plain', ScoreboardAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-2026warm"] && !Shopify.designMode) return;
  try {
    
  class Product2026Warm extends HTMLElement {
    connectedCallback() {
      this.setupScroller('[data-gallery-stage]', '[data-gallery-index]', '[data-gallery-prev]', '[data-gallery-next]');
      this.setupFeatureStory();
      this.storyStackCleanup = this.setupStoryStackSafe();
    }
    disconnectedCallback() {
      this.storyStackCleanup?.();
    }
    setupScroller(stageSelector, thumbSelector, prevSelector, nextSelector) {
      const stage = this.querySelector(stageSelector);
      if (!stage) return;
      const thumbs = [...this.querySelectorAll(thumbSelector)];
      const thumbsContainer = this.querySelector('[data-gallery-thumbs]');
      let index = 0;
      const galleryRatio = (image) => {
        const ratio = Number(image?.dataset.mediaRatio || 1);
        if (ratio >= 1.35) return '16 / 9';
        if (ratio <= 0.9) return '4 / 5';
        return '1 / 1';
      };
      const ensureThumbVisible = (button) => {
        if (!thumbsContainer || !button) return;
        const maxScroll = Math.max(0, thumbsContainer.scrollWidth - thumbsContainer.clientWidth);
        const containerRect = thumbsContainer.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();
        const buttonStart = thumbsContainer.scrollLeft + buttonRect.left - containerRect.left;
        const target = buttonStart - (thumbsContainer.clientWidth - buttonRect.width) / 2;
        thumbsContainer.scrollTo({ left: Math.max(0, Math.min(target, maxScroll)), behavior: 'smooth' });
      };
      const go = (next) => {
        index = Math.max(0, Math.min(next, stage.children.length - 1));
        stage.style.setProperty('--warm26-gallery-ratio', galleryRatio(stage.children[index]));
        stage.scrollTo({ left: stage.clientWidth * index, behavior: 'smooth' });
        thumbs.forEach((item, i) => item.classList.toggle('is-active', i === index));
        ensureThumbVisible(thumbs[index]);
      };
      thumbs.forEach((button) => button.addEventListener('click', () => go(Number(button.dataset.galleryIndex))));
      this.querySelector(prevSelector)?.addEventListener('click', () => go(index - 1));
      this.querySelector(nextSelector)?.addEventListener('click', () => go(index + 1));
      stage.addEventListener('scrollend', () => go(Math.round(stage.scrollLeft / stage.clientWidth)));
      stage.style.setProperty('--warm26-gallery-ratio', galleryRatio(stage.children[0]));
    }
    setupFeatureStory() {
      const track = this.querySelector('[data-feature-track]');
      const dots = this.querySelector('[data-feature-dots]');
      const copyTrack = this.querySelector('[data-feature-copy-track]');
      const copySlides = copyTrack ? [...copyTrack.querySelectorAll('[data-feature-copy-index]')] : [];
      if (!track || !dots) return;
      let index = 0;
      const count = track.children.length;
      const updateCopy = () => {
        copySlides.forEach((slide) => {
          const active = Number(slide.dataset.featureCopyIndex) === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      };
      const syncCopy = (behavior = 'smooth') => {
        if (!copyTrack || copySlides.length === 0) return;
        const maxScroll = Math.max(0, copyTrack.scrollWidth - copyTrack.clientWidth);
        const target = Math.max(0, maxScroll - copyTrack.clientWidth * index);
        copyTrack.scrollTo({ left: target, behavior });
      };
      const setIndex = (next, behavior = 'smooth') => {
        index = Math.max(0, Math.min(next, count - 1));
        track.scrollTo({ left: track.clientWidth * index, behavior });
        syncCopy(behavior);
        [...dots.children].forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        updateCopy();
      };
      const go = (next) => setIndex((next + count) % count);
      const settleTrack = () => {
        const width = Math.max(1, track.clientWidth);
        setIndex(Math.round(track.scrollLeft / width), 'auto');
      };
      let scrollTimer;
      for (let i = 0; i < count; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button'; dot.setAttribute('aria-label', `View feature ${i + 1}`);
        dot.addEventListener('click', () => go(i)); dots.append(dot);
      }
      this.querySelector('[data-feature-prev]')?.addEventListener('click', () => go(index - 1));
      this.querySelector('[data-feature-next]')?.addEventListener('click', () => go(index + 1));
      track.addEventListener('scrollend', settleTrack);
      track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(settleTrack, 90);
      }, { passive: true });
      if (copyTrack) copySlides.slice().reverse().forEach((slide) => copyTrack.append(slide));
      setIndex(0, 'auto');
      requestAnimationFrame(() => syncCopy('auto'));
    }
    setupStoryStackSafe() {
      const stack = this.querySelector('[data-story-stack]');
      const list = stack?.querySelector('[data-story-stack-list]');
      const cards = list ? [...list.querySelectorAll('[data-story-card]')] : [];
      const dots = stack?.querySelector('[data-story-dots]');
      if (!stack || !list || !dots || cards.length === 0) return;
      if (!window.gsap) {
        const retryCount = Number(stack.dataset.storyStackRetryCount || 0);
        if (retryCount >= 20) return;
        stack.dataset.storyStackRetryCount = String(retryCount + 1);
        const retry = () => this.setupStoryStackSafe();
        if (document.readyState === 'complete') window.setTimeout(retry, 0);
        else window.addEventListener('load', retry, { once: true });
        return;
      }
      delete stack.dataset.storyStackRetryCount;
      if (stack.dataset.storyStackReady === 'true') return;
      stack.dataset.storyStackReady = 'true';
      const { gsap } = window;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const storyCount = cards.length;
      const visibleCount = Math.min(4, storyCount);
      const duration = reducedMotion ? 0 : 0.42;
      let activeIndex = 0;
      let pointerId = null;
      let startX = 0;
      let currentX = 0;
      let dragging = false;
      const imageEvents = [];
      const syncCardDimensions = () => {
        const isMobile = window.matchMedia('(max-width:989px)').matches;
        const availableWidth = list.clientWidth || window.innerWidth;
        const availableHeight = list.clientHeight || (isMobile ? 620 : 700);
        const maxWidth = Math.min(availableWidth * (isMobile ? 0.84 : 0.72), isMobile ? 460 : 960);
        const maxHeight = Math.max(260, availableHeight - (isMobile ? 112 : 124));
        cards.forEach((card) => {
          const image = card.querySelector('img');
          const ratio = image?.naturalWidth && image.naturalHeight ? image.naturalWidth / image.naturalHeight : (isMobile ? 4 / 5 : 16 / 9);
          let width = maxWidth;
          let height = width / ratio;
          if (height > maxHeight) {
            height = maxHeight;
            width = height * ratio;
          }
          card.style.width = `${Math.round(width)}px`;
          card.style.height = `${Math.round(height)}px`;
          card.style.aspectRatio = 'auto';
        });
      };
      const layoutFor = (depth) => ({
        x: depth * 14,
        y: depth * 18,
        scale: 1 - depth * 0.045,
        opacity: depth < visibleCount ? 1 - depth * 0.16 : 0,
        rotation: 0,
        zIndex: 100 - depth
      });
      const render = (animate) => {
        cards.forEach((card, cardIndex) => {
          const depth = (cardIndex - activeIndex + storyCount) % storyCount;
          const vars = layoutFor(depth);
          if (animate) gsap.to(card, { ...vars, duration, ease: 'power2.out', overwrite: 'auto' });
          else gsap.set(card, vars);
          card.setAttribute('aria-hidden', depth === 0 ? 'false' : 'true');
        });
        [...dots.children].forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
      };
      const go = (nextIndex) => {
        const next = (nextIndex + storyCount) % storyCount;
        if (next === activeIndex) return;
        activeIndex = next;
        render(true);
      };
      const resetActive = () => {
        gsap.to(cards[activeIndex], { x: 0, rotation: 0, opacity: 1, duration, ease: 'power2.out', overwrite: 'auto' });
      };
      const onPointerDown = (event) => {
        if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        currentX = startX;
        dragging = true;
        list.classList.add('is-dragging');
        gsap.killTweensOf(cards[activeIndex]);
        list.setPointerCapture?.(pointerId);
      };
      const onPointerMove = (event) => {
        if (!dragging || event.pointerId !== pointerId) return;
        currentX = event.clientX;
        const delta = currentX - startX;
        if (Math.abs(delta) < 6) return;
        event.preventDefault();
        const limit = Math.max(120, list.clientWidth * 0.45);
        const offset = Math.max(-limit, Math.min(limit, delta));
        gsap.set(cards[activeIndex], { x: offset, rotation: (offset / Math.max(list.clientWidth, 1)) * 4, opacity: Math.max(0.45, 1 - Math.abs(offset) / Math.max(list.clientWidth, 1) * 0.5) });
      };
      const onPointerUp = (event) => {
        if (!dragging || event.pointerId !== pointerId) return;
        const delta = currentX - startX;
        dragging = false;
        list.classList.remove('is-dragging');
        list.releasePointerCapture?.(pointerId);
        pointerId = null;
        if (Math.abs(delta) >= Math.max(72, list.clientWidth * 0.18)) go(activeIndex + (delta < 0 ? 1 : -1));
        else resetActive();
      };
      const onPointerCancel = () => {
        if (!dragging) return;
        dragging = false;
        list.classList.remove('is-dragging');
        pointerId = null;
        resetActive();
      };
      dots.replaceChildren();
      for (let dotIndex = 0; dotIndex < storyCount; dotIndex += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `View story ${dotIndex + 1}`);
        dot.addEventListener('click', () => go(dotIndex));
        dots.append(dot);
      }
      stack.querySelector('[data-story-prev]')?.addEventListener('click', () => go(activeIndex - 1));
      stack.querySelector('[data-story-next]')?.addEventListener('click', () => go(activeIndex + 1));
      list.addEventListener('pointerdown', onPointerDown);
      list.addEventListener('pointermove', onPointerMove, { passive: false });
      list.addEventListener('pointerup', onPointerUp);
      list.addEventListener('pointercancel', onPointerCancel);
      list.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(activeIndex - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); go(activeIndex + 1); }
      });
      if (storyCount < 2) stack.classList.add('is-static');
      cards.forEach((card) => {
        const image = card.querySelector('img');
        if (!image) return;
        const onLoad = () => syncCardDimensions();
        image.addEventListener('load', onLoad);
        imageEvents.push([image, onLoad]);
      });
      const onResize = () => {
        syncCardDimensions();
        if (!dragging) render(false);
      };
      window.addEventListener('resize', onResize);
      syncCardDimensions();
      render(false);
      return () => {
        list.removeEventListener('pointerdown', onPointerDown);
        list.removeEventListener('pointermove', onPointerMove);
        list.removeEventListener('pointerup', onPointerUp);
        list.removeEventListener('pointercancel', onPointerCancel);
        window.removeEventListener('resize', onResize);
        imageEvents.forEach(([image, onLoad]) => image.removeEventListener('load', onLoad));
        gsap.killTweensOf(cards);
      };
    }
    setupStoryStack() {
      const stack = this.querySelector('[data-story-stack]');
      const pin = stack?.querySelector('[data-story-stack-pin]');
      const list = stack?.querySelector('[data-story-stack-list]');
      const sourceCards = list ? [...list.querySelectorAll('[data-story-card]')] : [];
      const dots = stack?.querySelector('[data-story-dots]');
      if (!stack || !pin || !list || !dots || sourceCards.length === 0) return;
      if (!window.gsap || !window.ScrollTrigger || !window.Draggable) {
        const retryCount = Number(stack.dataset.storyStackRetryCount || 0);
        if (retryCount >= 20) return;
        stack.dataset.storyStackRetryCount = String(retryCount + 1);
        const retry = () => this.setupStoryStack();
        if (document.readyState === 'complete') window.setTimeout(retry, 0);
        else window.addEventListener('load', retry, { once: true });
        return;
      }
      delete stack.dataset.storyStackRetryCount;
      if (stack.dataset.storyStackReady === 'true') return;
      stack.dataset.storyStackReady = 'true';
      const { gsap, ScrollTrigger, Draggable } = window;
      gsap.registerPlugin(ScrollTrigger, Draggable);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const storyCount = sourceCards.length;
      if (reducedMotion || storyCount < 2) {
        stack.classList.add('is-static');
        return;
      }
      const cards = [...sourceCards];
      const minimumCardCount = Math.max(16, storyCount * 2);
      while (cards.length < minimumCardCount) {
        const clone = sourceCards[cards.length % storyCount].cloneNode(true);
        clone.removeAttribute('data-story-card');
        clone.setAttribute('aria-hidden', 'true');
        list.append(clone);
        cards.push(clone);
      }

      /* Adapted from GreenSock's MIT-licensed CodePen (Copyright (c) 2026 GSAP): https://codepen.io/GreenSock/pen/RwKwLWK */
      let iteration = 0;
      let lastDotIndex = -1;
      const spacing = 0.1;
      const snapTime = gsap.utils.snap(spacing);
      const animateFunc = (element) => {
        const timeline = gsap.timeline();
        timeline.fromTo(element, { scale: 0, opacity: 0 }, { scale: 1, opacity: 1, zIndex: 100, duration: 0.5, yoyo: true, repeat: 1, ease: 'power1.in', immediateRender: false })
          .fromTo(element, { xPercent: 400 }, { xPercent: -400, duration: 1, ease: 'none', immediateRender: false }, 0);
        return timeline;
      };
      gsap.set(cards, { xPercent: 400, opacity: 0, scale: 0 });
      const seamlessLoop = this.buildStorySeamlessLoop(cards, spacing, animateFunc);
      const playhead = { offset: 0 };
      const wrapTime = gsap.utils.wrap(0, seamlessLoop.duration());
      const scrub = gsap.to(playhead, {
        offset: 0,
        onUpdate: () => { seamlessLoop.time(wrapTime(playhead.offset)); updateDots(); },
        duration: 0.5,
        ease: 'power3',
        paused: true
      });
      const distance = () => Math.max(1800, window.innerHeight * Math.max(storyCount, 3) * 0.8);
      const trigger = ScrollTrigger.create({
        trigger: stack,
        start: 'top top',
        end: () => `+=${distance()}`,
        pin,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onUpdate: (self) => {
          const scroll = self.scroll();
          if (scroll > self.end - 1) wrap(1, 2);
          else if (scroll < 1 && self.direction < 0) wrap(-1, self.end - 2);
          else {
            scrub.vars.offset = (iteration + self.progress) * seamlessLoop.duration();
            scrub.invalidate().restart();
          }
        }
      });
      const progressToScroll = (progress) => gsap.utils.clamp(1, trigger.end - 1, gsap.utils.wrap(0, 1, progress) * trigger.end);
      function wrap(iterationDelta, scrollTo) {
        iteration += iterationDelta;
        trigger.scroll(scrollTo);
        trigger.update();
      }
      const currentDotIndex = () => {
        const slot = Math.round(scrub.vars.offset / spacing);
        return ((slot % storyCount) + storyCount) % storyCount;
      };
      function updateDots() {
        const activeIndex = currentDotIndex();
        if (activeIndex === lastDotIndex) return;
        lastDotIndex = activeIndex;
        [...dots.children].forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
        cards.forEach((card, cardIndex) => card.classList.toggle('is-active', cardIndex % storyCount === activeIndex));
      }
      const scrollToOffset = (offset) => {
        const snappedTime = snapTime(offset);
        const progress = (snappedTime - seamlessLoop.duration() * iteration) / seamlessLoop.duration();
        const scroll = progressToScroll(progress);
        if (progress >= 1 || progress < 0) wrap(Math.floor(progress), scroll);
        else trigger.scroll(scroll);
      };
      const jumpToDot = (targetIndex) => {
        const currentIndex = currentDotIndex();
        let delta = targetIndex - currentIndex;
        if (delta > storyCount / 2) delta -= storyCount;
        if (delta < -storyCount / 2) delta += storyCount;
        scrollToOffset(scrub.vars.offset + delta * spacing);
      };
      const scrollEndHandler = () => { if (trigger.isActive) scrollToOffset(scrub.vars.offset); };
      ScrollTrigger.addEventListener('scrollEnd', scrollEndHandler);
      for (let dotIndex = 0; dotIndex < storyCount; dotIndex += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `View story ${dotIndex + 1}`);
        dot.addEventListener('click', () => jumpToDot(dotIndex));
        dots.append(dot);
      }
      stack.querySelector('[data-story-prev]')?.addEventListener('click', () => scrollToOffset(scrub.vars.offset - spacing));
      stack.querySelector('[data-story-next]')?.addEventListener('click', () => scrollToOffset(scrub.vars.offset + spacing));
      list.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); scrollToOffset(scrub.vars.offset - spacing); }
        if (event.key === 'ArrowRight') { event.preventDefault(); scrollToOffset(scrub.vars.offset + spacing); }
      });
      const [draggable] = Draggable.create(this.querySelector('[data-story-stack-drag-proxy]'), {
        type: 'x',
        trigger: list,
        onPress() { this.startOffset = scrub.vars.offset; },
        onDrag() {
          scrub.vars.offset = this.startOffset + (this.startX - this.x) * 0.0002;
          scrub.invalidate().restart();
        },
        onDragEnd() { scrollToOffset(scrub.vars.offset); }
      });
      scrub.vars.offset = 0;
      scrub.invalidate().restart();
      updateDots();
      return () => {
        ScrollTrigger.removeEventListener('scrollEnd', scrollEndHandler);
        draggable?.kill();
        scrub.kill();
        seamlessLoop.kill();
        trigger.kill();
      };
    }
    buildStorySeamlessLoop(items, spacing, animateFunc) {
      const { gsap } = window;
      const overlap = Math.ceil(1 / spacing);
      const startTime = items.length * spacing + 0.5;
      const loopTime = (items.length + overlap) * spacing + 1;
      const rawSequence = gsap.timeline({ paused: true });
      const seamlessLoop = gsap.timeline({
        paused: true,
        repeat: -1,
        onRepeat() { this._time === this._dur && (this._tTime += this._dur - 0.01); }
      });
      const total = items.length + overlap * 2;
      for (let i = 0; i < total; i += 1) {
        const index = i % items.length;
        const time = i * spacing;
        rawSequence.add(animateFunc(items[index]), time);
        if (i <= items.length) seamlessLoop.add(`label${i}`, time);
      }
      rawSequence.time(startTime);
      seamlessLoop.to(rawSequence, { time: loopTime, duration: loopTime - startTime, ease: 'none' })
        .fromTo(rawSequence, { time: overlap * spacing + 1 }, { time: startTime, duration: startTime - (overlap * spacing + 1), immediateRender: false, ease: 'none' });
      return seamlessLoop;
    }
  }
  if (!customElements.get('product-2026warm')) customElements.define('product-2026warm', Product2026Warm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["winter-home"] && !Shopify.designMode) return;
  try {
    
  class WinterDiscountCode extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.defaultContent = this.querySelector('.winter-home__code-default');
      this.status = this.querySelector('.winter-home__code-status');
      this.statusText = this.querySelector('.winter-home__code-status-text');
      this.code = (this.dataset.code || '').trim();
      this.successText = this.dataset.success || 'Copied';

      if (!this.button || !this.code || this.button.dataset.bound === 'true') return;

      this.button.dataset.bound = 'true';
      this.button.addEventListener('click', () => this.copyCode());
    }

    async copyCode() {
      let copied = false;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(this.code);
          copied = true;
        }
      } catch (error) {
        copied = false;
      }

      if (!copied) {
        const input = document.createElement('input');
        input.value = this.code;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        copied = document.execCommand('copy');
        input.remove();
      }

      if (!copied) return;

      try {
        await fetch(`/discount/${encodeURIComponent(this.code)}?redirect=/cart.js`, {
          credentials: 'same-origin',
        });
        window.localStorage.setItem('winterDiscountCode', this.code);
      } catch (error) {
        window.localStorage.setItem('winterDiscountCode', this.code);
      }

      this.classList.add('is-copied');
      if (this.statusText) this.statusText.textContent = this.successText;
      if (this.defaultContent) this.defaultContent.hidden = true;
      if (this.status) this.status.hidden = false;
      this.button.setAttribute('aria-label', this.successText);
    }
  }

  if (!customElements.get('winter-discount-code')) {
    customElements.define('winter-discount-code', WinterDiscountCode);
  }

  const bindWinterVariantSelectors = () => {
    document.querySelectorAll('[data-winter-quantity]').forEach((control) => {
      if (control.dataset.bound) return;
      const input = control.querySelector('input');
      const minus = control.querySelector('[data-quantity-minus]');
      const plus = control.querySelector('[data-quantity-plus]');
      if (!input || !minus || !plus) return;

      control.dataset.bound = 'true';
      const setQuantity = (quantity) => {
        input.value = String(Math.max(1, Number.parseInt(quantity, 10) || 1));
      };
      minus.addEventListener('click', () => setQuantity(Number(input.value) - 1));
      plus.addEventListener('click', () => setQuantity(Number(input.value) + 1));
      input.addEventListener('change', () => setQuantity(input.value));
    });

    document.querySelectorAll('[data-winter-preview-variant]').forEach((select) => {
      if (select.dataset.bound) return;
      select.dataset.bound = 'true';
      const update = () => {
        const card = select.closest('.winter-home__product-card');
        card.querySelector('.winter-home__product-price').textContent = select.selectedOptions[0].dataset.price;
        card.querySelector('.winter-home__product-specs > span:nth-child(3) strong').textContent =
          select.value === 'digital' ? 'Digital thermostat' : 'Manual';
      };
      select.addEventListener('change', update);
      update();
    });
    document.querySelectorAll('[data-winter-variant-select]').forEach((select) => {
      if (!(select instanceof HTMLSelectElement) || select.dataset.bound === 'true') return;

      const card = select.closest('.winter-home__product-card');
      const formComponent = card?.querySelector('product-form-component');
      const variantInput = formComponent?.querySelector('[ref="variantId"]');
      const addButton = formComponent?.querySelector('[ref="addToCartButton"]');
      if (!variantInput) return;

      select.dataset.bound = 'true';
      const update = () => {
        const selected = select.options[select.selectedIndex];
        variantInput.value = selected?.value || '';
        const price = card?.querySelector('.winter-home__product-price');
        if (price && selected?.dataset.price) price.textContent = selected.dataset.price;
        if (addButton instanceof HTMLButtonElement) {
          addButton.disabled = selected?.dataset.available !== 'true';
        }
      };
      select.addEventListener('change', update);
      update();
    });
  };

  const bindWinterFeatureSliders = () => {
    document.querySelectorAll('.winter-home__features-inner').forEach((track) => {
      if (track.dataset.featureSliderBound === 'true') return;

      const cards = Array.from(track.querySelectorAll('.winter-home__feature-card'));
      const section = track.closest('.winter-home__features');
      const dots = section ? Array.from(section.querySelectorAll('[data-feature-dot]')) : [];
      if (!cards.length) return;

      track.dataset.featureSliderBound = 'true';
      let activeIndex = 0;
      let scrollFrame = 0;
      let dragPointerId = null;
      let dragStartX = 0;
      let dragStartScroll = 0;
      let hasDragged = false;
      let suppressClick = false;
      let scrollTargetIndex = null;
      let settleTimer = 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const setActiveDot = (index) => {
        if (!dots.length || activeIndex === index) return;
        activeIndex = index;
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-pressed', String(isActive));
        });
      };

      const updateActiveDot = () => {
        scrollFrame = 0;
        if (!dots.length || scrollTargetIndex !== null) return;

        const trackRect = track.getBoundingClientRect();
        const trackCenter = trackRect.left;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        cards.forEach((card, index) => {
          const cardRect = card.getBoundingClientRect();
          const cardCenter = cardRect.left;
          const distance = Math.abs(cardCenter - trackCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) closestIndex = cards.length - 1;
        setActiveDot(closestIndex);
      };

      const scheduleActiveDot = () => {
        if (!scrollFrame) scrollFrame = requestAnimationFrame(updateActiveDot);
      };

      const scrollToCard = (index) => {
        const card = cards[index];
        if (!card) return;

        scrollTargetIndex = index;
        track.scrollTo({
          left: track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left,
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
        setActiveDot(index);
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(
          () => {
            scrollTargetIndex = null;
            updateActiveDot();
          },
          reducedMotion ? 50 : 400
        );
      };

      const previous = section.querySelector('[data-feature-prev]');
      const next = section.querySelector('[data-feature-next]');
      const updateArrows = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      previous.addEventListener('click', () => scrollToCard(Math.max(0, activeIndex - 1)));
      next.addEventListener('click', () => scrollToCard(Math.min(cards.length - 1, activeIndex + 1)));
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows, { passive: true });
      updateArrows();
      track.addEventListener('scroll', scheduleActiveDot, { passive: true });
      window.addEventListener('resize', scheduleActiveDot, { passive: true });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => scrollToCard(index));
      });

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        dragPointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartScroll = track.scrollLeft;
        hasDragged = false;
        scrollTargetIndex = null;
        window.clearTimeout(settleTimer);
        track.classList.add('is-dragging');
        track.setPointerCapture?.(event.pointerId);
      });

      track.addEventListener('pointermove', (event) => {
        if (dragPointerId !== event.pointerId) return;

        const distance = event.clientX - dragStartX;
        if (Math.abs(distance) > 4) hasDragged = true;
        if (!hasDragged) return;

        event.preventDefault();
        track.scrollLeft = dragStartScroll - distance;
      });

      const finishDrag = (event) => {
        if (dragPointerId !== event.pointerId) return;

        track.classList.remove('is-dragging');
        track.releasePointerCapture?.(event.pointerId);
        dragPointerId = null;
        if (hasDragged) suppressClick = true;
        scheduleActiveDot();
      };

      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
        },
        true
      );

      updateActiveDot();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        bindWinterVariantSelectors();
        bindWinterFeatureSliders();
      },
      { once: true }
    );
  } else {
    bindWinterVariantSelectors();
    bindWinterFeatureSliders();
  }

  } catch(e) { console.error(e); }
})();
})();
